export default __webpack_public_path__ + "static/media/Shot_14.0000.7652192f.png";